import React from 'react';
import { AllClaims } from '../../components/admin/AllClaims';

export const DebtCollection = () => {
  // Only show claims with this payment status
  const filterPaymentStatus = "Debt collection initiated";

  return (
    <>
      <AllClaims filterPaymentStatus={filterPaymentStatus} />
    </>
  );
};
